jQuery(function($) {
	$.scrollUp({
		scrollText: '<i class="fa fa-chevron-up"></i>',
		zIndex: '3',
	});
	$('#scrollUp').addClass('btn btn-default');

	var styles = {
		bottom: '8em',
		right: '2em',
		background: 'rgb(125, 30, 38)',
		color: 'rgb(255, 255, 255)',
	};

	$.each(styles, function(k, v) {
		$('#scrollUp').css(k, v);
	});
});
